import { GetLocationsResponse } from '../api/location';

type Location = GetLocationsResponse['result'][0];

type GetLocationStrings = {
  truncated: string;
  allLocations: string;
  allCountries: string;
  countriesTruncated: string;
};

export function getLocationStrings(
  locations: Location[] = [],
  visibleLocations = 1,
): GetLocationStrings {
  if (locations.length === 0) {
    return {
      truncated: '',
      allLocations: '',
      allCountries: '',
      countriesTruncated: '',
    };
  }

  const countries = new Set<string>();
  const visibleCountriesOrWaterBodies = new Set<string>();
  const subdivisionsPerCountryOrWater: Record<string, string[]> = {};
  locations.forEach((location, index) => {
    const countryName = location.country?.name;
    const subdivisionName = location.subdivision?.name;
    const waterName = location.water?.name;
    const mainEntityName = (countryName ?? waterName) as string;

    if (countryName) {
      countries.add(countryName);
    }

    if (index < visibleLocations) {
      visibleCountriesOrWaterBodies.add(mainEntityName);
    }

    if (!subdivisionsPerCountryOrWater[mainEntityName]) {
      subdivisionsPerCountryOrWater[mainEntityName] = [];
    }

    if (subdivisionName) {
      subdivisionsPerCountryOrWater[mainEntityName].push(subdivisionName);
    }
  });

  const allLocations = Object.keys(subdivisionsPerCountryOrWater).reduce<Array<string>>(
    (locationStrings, mainEntityName) => {
      const subdivisions = subdivisionsPerCountryOrWater[mainEntityName];
      const locationString = subdivisions.length
        ? `${mainEntityName} (${subdivisions.join(', ')})`
        : mainEntityName;

      locationStrings.push(locationString);

      return locationStrings;
    },
    [],
  );

  const truncated = [...visibleCountriesOrWaterBodies].sort();
  const numberOfLocations =
    locations.length > visibleLocations ? ` +${locations.length - visibleLocations} locations` : '';

  const sortedCountries = [...countries].sort();
  const numberOfCountries =
    sortedCountries.length > visibleLocations
      ? ` + ${sortedCountries.length - visibleLocations} countries`
      : '';

  return {
    truncated: `${truncated.join(', ')}${numberOfLocations}`,
    allLocations: allLocations.join('\n'),
    allCountries: sortedCountries.join(', '),
    countriesTruncated: `${sortedCountries
      .slice(0, visibleLocations)
      .join(', ')}${numberOfCountries}`,
  };
}
